<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>James Bovill once spent six weeks in a renovation project, using a jackhammer to dig up the floors of the Vauxhall factory in Luton; on another occasion he was the MC to Archbishop Scanlan at the consecration of the Church of the Immaculate Conception in Maryhill, Glasgow. Now poised between these extremes, he works as an examiner for the IBO. Until he retired some years ago, he taught English to secondary pupils in a number of schools in the Glasgow area, where he still lives. He has three daughters, three grandchildren, and since 2009, has enjoyed the companionship of a lady from New Jersey, USA. He claims to be influenced by the work of Bob Dylan, to keep him happy, and the work of Leonard Cohen, to keep him from getting too happy. He claims his sixth novel, Old Crow, is a further search for his origins.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?10f785f9